import {ACTION_CODE} from './_actionCode';
import {TrainingStudentTypesService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'CREATE_TRAINING_STUDENTTYPE';

export async function createTrainingStudentType(
    userData: Record<string, string>,
    newTrainingStudentType: Record<string, any>
) {
    try {
        LoggerService.logInfo('Action - createTrainingStudentType - Start');

        const createTrainingStudentTypeResult = await TrainingStudentTypesService.createTrainingStudentType(userData, newTrainingStudentType);

        LoggerService.logInfo('Action - createTrainingStudentType - End - Success');

        return ResultModel.newSuccessResult(createTrainingStudentTypeResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - createTrainingStudentType - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
